import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useTypedParams } from '@repo/routes';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from '@repo/ui-primitives/breadcrumb';
import { Link } from '@tanstack/react-router';
import { OrgSelectorDropdown } from './org-selector-dropdown';
export function AppBreadcrumb() {
    const { organization, project, application } = useTypedParams();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(OrgSelectorDropdown, {}),
            /*#__PURE__*/ _jsx(Breadcrumb, {
                children: /*#__PURE__*/ _jsxs(BreadcrumbList, {
                    children: [
                        project && organization && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(BreadcrumbSeparator, {
                                    className: "px-2"
                                }),
                                /*#__PURE__*/ _jsx(BreadcrumbItem, {
                                    children: application ? /*#__PURE__*/ _jsx(BreadcrumbLink, {
                                        asChild: true,
                                        children: /*#__PURE__*/ _jsx(Link, {
                                            to: "/org/$organization/$project",
                                            params: {
                                                organization,
                                                project
                                            },
                                            children: project
                                        })
                                    }) : /*#__PURE__*/ _jsx(BreadcrumbPage, {
                                        children: project
                                    })
                                })
                            ]
                        }),
                        application && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(BreadcrumbSeparator, {
                                    className: "px-2"
                                }),
                                /*#__PURE__*/ _jsx(BreadcrumbItem, {
                                    children: /*#__PURE__*/ _jsx(BreadcrumbPage, {
                                        children: application
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
